module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "clockContainer"
  }, [_c('div', {
    staticClass: "clock"
  }, [_c('ul', _vm._l((String(Math.round(_vm.goods * 1.5))), function(item, index) {
    return _c('li', {
      staticClass: "flipLi"
    }, [_vm._v("\n            " + _vm._s(item) + "\n          ")])
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c379720e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flipnum.vue
// module id = 143
// module chunks = 1